import removeItemFromCart from './remove-item-from-cart';

type MoveToFavoritesProps = {
    item: CartItem;
    itemIndex?: number;
    changeFavorite: (material: Material, add: boolean) => void;
    reset: (cart: Cart) => void;
};

const moveToFavorites = ({ item, itemIndex, changeFavorite, reset }: MoveToFavoritesProps): void => {
    changeFavorite(item.material, true);

    removeItemFromCart({ item, itemIndex, reset });
};

export default moveToFavorites;
